<div
  class="bg-[#0A0E1F] text-white min-h-screen flex flex-col items-center space-y-3 py-10"
>
<h2 class="text-xl lg:text-[22px] font-semibold text-white">
  <span class="text-[#19E4E0] border-b-2 border-[#19E4E0]">Epic Arcade</span>
  Games
</h2>
<h1 class="text-2xl lg:text-[42px] font-bold mt-0">Play & Level Up Gaming</h1>
<p class="mt-0 text-[12px] lg:text-[16px] text-gray-400 text-center max-w-2xl px-4">
  Join the next generation of gaming where entertainment meets community. Play 
  smart, unlock achievements, and watch your rank grow.
</p>

  <div
    class="flex flex-wrap gap-4 lg:mt-4 px-0 lg:px-4 py-2 bg-transparent lg:bg-[#1B223B] justify-center sm:justify-start"
  >
    <button
      *ngFor="let tab of tabs"
      class="lg:px-4 py-2 px-[8px] rounded-lg font-medium border border-gray-400 transition-colors duration-200 lg:text-sm text-xs"
      [ngClass]="{
        '--button border-0': activeTab === tab.value,
        'text-gray-400': activeTab !== tab.value,
      }"
      (click)="onTabChange(tab.value)"
    >
      {{ tab.label }}
    </button>
  </div>

  <!-- Grid Container -->
  <div class="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-6 py-0 lg:py-8">
    <ng-container *ngFor="let game of displayedGames; let i = index">
      <div class="relative w-full h-[220px] lg:h-[350px]">
        <!-- [class.hidden]="i > 3"
        [class.lg:block]="i > 3" -->
        <!-- SVG background -->
        <svg
          class="absolute inset-0 w-full h-full rotate-180"
          viewBox="0 0 323 350"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.5 22.5L36.0411 7.60659C41.8248 2.69589 49.1653 0 56.7525 0H271.13C280.27 0 288.974 3.90873 295.047 10.7404L305.5 22.5L313.944 31.1851C319.751 37.1583 323 45.1607 323 53.4916V296.976C323 304.728 320.187 312.215 315.082 318.049L305.5 329L294.958 340.069C288.918 346.411 280.543 350 271.786 350H56.1421C48.9265 350 41.9226 347.561 36.2675 343.08L20.4377 330.536C19.1478 329.513 17.9387 328.393 16.8211 327.185L8.50882 318.199C3.0385 312.285 0 304.525 0 296.469V54.0123C0 45.3734 3.4929 37.1015 9.68464 31.0771L18.5 22.5Z"
            fill="#1B223B"
          />
          <g filter="url(#filter0_i)">
            <path
              d="M18.5 22.5L36.0411 7.60659C41.8248 2.69589 49.1653 0 56.7525 0H271.13C280.27 0 288.974 3.90873 295.047 10.7404L305.5 22.5L313.944 31.1851C319.751 37.1583 323 45.1607 323 53.4916V296.976C323 304.728 320.187 312.215 315.082 318.049L305.5 329L294.958 340.069C288.918 346.411 280.543 350 271.786 350H56.1421C48.9265 350 41.9226 347.561 36.2675 343.08L20.4377 330.536C19.1478 329.513 17.9387 328.393 16.8211 327.185L8.50882 318.199C3.0385 312.285 0 304.525 0 296.469V54.0123C0 45.3734 3.4929 37.1015 9.68464 31.0771L18.5 22.5Z"
              fill="#1B223B"
            />
          </g>
          <defs>
            <filter
              id="filter0_i"
              x="0"
              y="0"
              width="323"
              height="354"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="SourceAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0989876
                        0 0 0 0 0.895192
                        0 0 0 0 0.88017
                        0 0 0 1 0"
              />
              <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </svg>

        <!-- Card content -->
        <div class="relative z-10 flex flex-col items-center p-4 text-white">
          <!-- <div class="w-full flex justify-end px-3 absolute right-3 z-40">
            
            <span *ngIf="game?.isHot" class="flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-[#0A0E1F]/80 backdrop-blur-md border border-[#7DE7E5]/30 shadow-[0_0_10px_rgba(125,231,229,0.2)]">
              <span class="w-2 h-2 rounded-full bg-gradient-to-r from-[#FF4D4D] to-[#FF8C00] animate-pulse"></span>
              <span class="text-[12px] font-bold text-white tracking-widest uppercase">Hot</span>
            </span>
          </div> -->
          <div
            class="flex justify-between items-center absolute left-5 right-5 z-40 mb-1 "
          >
            <span
              *ngIf="game?.bonus > 0"
              class="flex flex-col items-center justify-center bg-gradient-to-b from-[#f3c87a] to-[#ba8b42] rounded-full px-2 py-0.5 text-black font-bold text-center shadow-lg"
            >
              <span class="text-[13px] font-bold leading-[1]"
                >{{ game?.bonus }}%</span
              >
              <span class="text-[8px] leading-[1]">BONUS</span>
            </span>

            <!-- <span
              *ngIf="game?.isHot"
              class="flex items-center gap-1 px-2 py-1 rounded-full bg-white/10 backdrop-blur-md text-[9px] sm:text-[10px] md:text-[12px] font-bold text-white shadow-[0_2px_6px_rgba(255,255,255,0.2)]"
            >
              <span
                class="w-5 h-5 rounded-full bg-gradient-to-r from-orange-500 to-red-600 flex-shrink-0"
              ></span>
              <span class="text-[#F2C749]">HOT</span>
            </span> -->
            <span
              *ngIf="game?.isHot"
              class="flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-[#0A0E1F]/80 backdrop-blur-md border border-[#7DE7E5]/30 shadow-[0_0_10px_rgba(125,231,229,0.2)]"
            >
              <span
                class="w-2 h-2 rounded-full bg-gradient-to-r from-orange-500 to-red-600 animate-pulse"
              ></span>
              <span
                class="text-[12px] font-bold text-white tracking-widest uppercase"
                >Hot</span
              >
            </span>
          </div>
          <img
            [src]="getGameImage(game.name)?.coverImage"
            [alt]="game.name"
            class="h-[110px] mb-0 w-[289px] rounded-tl-[40px] rounded-tr-[40px] object-cover z-0 md:h-[213px] md:mb-4 md:mt-0"
          />

          <div
            class="bg-[#1B223B] rounded-full w-[97px] h-[97px] flex items-center justify-center -mt-[70px] z-10"
          >
            <img
              [src]="getGameImage(game.name)?.image"
              [alt]="game.name + ' icon'"
              class="w-[70px] h-[70px] object-contain"
            />
          </div>
          <h3 class="text-lg font-semibold mb-0 lg:mb-2">
            {{ game?.name?.toUpperCase() }}
          </h3>
          <!-- <p class="text-sm text-[#19E4E0]">{{ game.gameType }}</p> -->
        </div>
      </div>
    </ng-container>
    <div *ngIf="hasMoreGames" class="col-span-full flex justify-center mt-4">
      <button
        class="mt-3 --button text-gray-800 font-semibold text-sm sm:text-base py-2 px-4 sm:px-5 rounded-md hover:bg-white transition"
        (click)="toggleShowAll()"
      >
        {{ showAllGames ? "Show less" : "Show more" }}
      </button>
    </div>
  </div>
</div>
